export default __webpack_public_path__ + "static/ogp-410c0f2ad18036053cae5d04da24a1bd.png";